import React, { useEffect, useState } from 'react';
import { IonCol, IonGrid, IonRow, IonButton, IonIcon, IonMenu, IonContent, IonLabel, IonRange, IonCheckbox } from '@ionic/react';
import {

  contract,
  create,
  expand,
  help,
  searchCircle,
  shuffle,
  swapHorizontal,
  swapVertical,
  text,
  // Include other icons you might need
} from 'ionicons/icons';
import { logMe } from '../foo/user';
import { useHistory } from 'react-router';
import { _NEW_LINE, _SMALL_SCREEN_WIDTH, _defaultParams, _dict } from './constants';
import { useURLStore } from './stateManagement/URLZustand';
import { useGlobalStore } from './stateManagement/globalZustand';
import { useUserStore } from './stateManagement/userZustand';
import { useUIStore } from './stateManagement/UIZustand';
import { useTreeStore } from './stateManagement/treeZustand';
import SubscriptionAlert from './dialogs/SubscriptionAlertBeforeArtistic';
import ButtonTemplate from './templates/ButtonTemplate';
import './SidebarMenu.css';
 
const SidebarMenu: React.FC = () => {  
  const history = useHistory();
  const { getURLTo, URLVars } = useURLStore();
  const { isParentMode, lang } = useGlobalStore();
  const { visibleLabels } = useURLStore();
  const [ showSubscriptionAlertForArtistic, setShowSubscriptionAlertForArtistic ] = useState<boolean>(false);
  const { windowSize, isGridMode  } = useUIStore();
  const { path2Params, setPath2Params, defaultParams, setDefaultParams } = useTreeStore();

  const [ fontSize, setFontSize] = useState<number>(); // Default font size
  const [ cardWidth, setCardWidth] = useState<number>(); // Default card width
  const [ isRandomFlag, setIsRandomFlag] = useState<boolean>();
  const [ invertImgTxt, setInvertImgTxt] = useState<boolean>();
  const [ capitalizeText, setCapitalizeText] = useState<number>();
  const [ nrCols, setNrCols] = useState<number>(); // Default number of columns
  const [ setDefault, setSetDefault] = useState<boolean>();

  const [ areDefaultParamsUpdated, setAreDefaultParamsUpdated ] = useState<boolean>();

  //console.log("defaultParams", defaultParams)
  useEffect(() => {
    // If defaultParams has undefined property, take it from _defaultParams
    const updatedDefaultParams = {
      ...defaultParams,
      fontSize: defaultParams.fontSize ?? _defaultParams.fontSize,
      cardWidth: defaultParams.cardWidth ?? _defaultParams.cardWidth,
      isRandomFlag: defaultParams.isRandomFlag ?? _defaultParams.isRandomFlag,
      invertImgTxt: defaultParams.invertImgTxt ?? _defaultParams.invertImgTxt,
      capitalizeText: defaultParams.capitalizeText ?? _defaultParams.capitalizeText,
      nrCols: defaultParams.nrCols ?? _defaultParams.nrCols,
    };
    setDefaultParams(updatedDefaultParams);

    // Check if the current ones are the same as the default ones
    if(path2Params[URLVars.nodePath!]?.cardWidth === defaultParams.cardWidth
      && path2Params[URLVars.nodePath!]?.fontSize === defaultParams.fontSize
      && path2Params[URLVars.nodePath!]?.isRandomFlag === defaultParams.isRandomFlag
      && path2Params[URLVars.nodePath!]?.invertImgTxt === defaultParams.invertImgTxt
      && path2Params[URLVars.nodePath!]?.capitalizeText === defaultParams.capitalizeText
      && path2Params[URLVars.nodePath!]?.nrCols === defaultParams.nrCols
    ){
        setSetDefault(true);
    }

    // Update the component initial states
    setFontSize(path2Params[URLVars.nodePath!]?.fontSize || updatedDefaultParams.fontSize);
    setCardWidth(path2Params[URLVars.nodePath!]?.cardWidth || updatedDefaultParams.cardWidth);
    setIsRandomFlag(path2Params[URLVars.nodePath!]?.isRandomFlag || updatedDefaultParams.isRandomFlag);
    setInvertImgTxt(path2Params[URLVars.nodePath!]?.invertImgTxt || updatedDefaultParams.invertImgTxt);
    setCapitalizeText(path2Params[URLVars.nodePath!]?.capitalizeText || updatedDefaultParams.capitalizeText);
    setNrCols(path2Params[URLVars.nodePath!]?.nrCols || updatedDefaultParams.nrCols);
    
    setAreDefaultParamsUpdated(true);
  }, []);

  useEffect(() => {
    if(areDefaultParamsUpdated){
      // Update path2Params with the new values
      setPath2Params({ ...path2Params, [URLVars.nodePath!]: { ...path2Params[URLVars.nodePath!],
        fontSize: fontSize, cardWidth: cardWidth, isRandomFlag: isRandomFlag,
        invertImgTxt: invertImgTxt, capitalizeText: capitalizeText, nrCols: nrCols } });
    }
  }, [fontSize, cardWidth, isRandomFlag, invertImgTxt, capitalizeText, nrCols, setDefault, areDefaultParamsUpdated]);
  
  
  let capTxt = "";
  if(capitalizeText === 1){
    capTxt = _dict.allCapitalLetters[lang];
  }else if(capitalizeText === 2){
    capTxt = _dict.allSmallLetters[lang];
  }else if(capitalizeText === 3){
    capTxt = _dict.hideText[lang];
  }else if(capitalizeText === 4){
    capTxt = _dict.normalText[lang];
  }

  const toggleRandomFlag = () => {
    setIsRandomFlag(!isRandomFlag);
  };

  const doInvertImgTxt = () => {
    setInvertImgTxt(!invertImgTxt);
  };

  const doCapitalizeText = () => {    
    let newCapitalizeText = 1;
    // 1 -> 2 -> 3 -> 4 -> 1
    if (capitalizeText === 1) {
      newCapitalizeText = 2;
    } else if (capitalizeText === 2) {
      newCapitalizeText = 3;
    } else if (capitalizeText === 3) {
      newCapitalizeText = 4;
    } else if (capitalizeText === 4) {
      newCapitalizeText = 1;
    }
    setCapitalizeText(newCapitalizeText);
  };



  
  
  const invertButton = <ButtonTemplate icon={swapVertical} text={_dict.invertImgTxt[lang]} onClick={() => {
    logMe("click_invert", {});
    doInvertImgTxt();
  }} />;

  const capitalizeButton = <ButtonTemplate icon={text} text={capTxt} onClick={() => {
    logMe("click_capitalize", {});
    doCapitalizeText();
  }} />;

  

  const activateRandomOrderBtn = <ButtonTemplate icon={shuffle} text={_dict.randomOrderText[lang]} onClick={() => {
    logMe("click_randomOrder",{});
    toggleRandomFlag();
  }} isBlack={isRandomFlag} />;


  


  
  return (
    <IonCol
      size="3"
      style={{
        overflowY: 'scroll',
        maxHeight: '100vh',
        minHeight: '100vh',
        maxWidth: '300px',
        minWidth: '204px',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        backgroundColor: '#333333',
        padding: 0,
        margin: 0,
      }}
    >
      <IonGrid>

        <IonRow class="ion-justify-content-center ion-align-items-center">
        {isGridMode && <IonCol size="12" class="ion-text-center">
            <IonLabel style={{ color: 'white' }}>{_dict.nrCols[lang]}</IonLabel>
            <IonRange
              min={1}
              max={10}
              step={1}
              value={nrCols}
              pin={true}
              onIonChange={(e) => setNrCols(e.detail.value as number)}
              onIonInput={(e) => setNrCols(e.detail.value as number)}
            ></IonRange>
          </IonCol>}
          
          
          <IonCol size="12" class="ion-text-center">
            <IonLabel style={{ color: 'white' }}>{_dict.fontSize[lang]}</IonLabel>
            <IonRange
              min={10}
              max={36}
              step={1}
              value={fontSize}
              pin={true}
              onIonChange={(e) => setFontSize(e.detail.value as number)}
              onIonInput={(e) => setFontSize(e.detail.value as number)}
            ></IonRange>
          </IonCol>

          <IonCol size="12" class="ion-text-center">
            <IonLabel style={{ color: 'white' }}>{_dict.cardSize[lang]}</IonLabel>
            <IonRange
              min={100}
              max={300}
              step={10}
              value={cardWidth}
              pin={true}
              onIonChange={(e) => setCardWidth(e.detail.value as number)}
              onIonInput={(e) => setCardWidth(e.detail.value as number)}
            >
            </IonRange>
          </IonCol>


          
          <IonCol size="12" class="ion-text-center">
            {isParentMode === true && visibleLabels && visibleLabels?.length > 0 && invertButton}
          </IonCol>
          <IonCol size="12" class="ion-text-center">
            {isParentMode === true && visibleLabels && visibleLabels?.length > 0 && capitalizeButton}
          </IonCol>
          
          <IonCol size="12" class="ion-text-center">
            {isParentMode === true && visibleLabels && visibleLabels?.length > 0 && activateRandomOrderBtn}
          </IonCol>
          <IonCol size="12" class="ion-align-items-center ion-justify-content-start" style={{ display: 'flex', alignItems: 'center' }}>
            <IonCheckbox checked={setDefault} onIonChange={(e) => setSetDefault(e.detail.checked)} />
            <IonLabel style={{ marginLeft: '10px', color:"lightgray" }}>{_dict.setPropertiesAsDefaultForAllBranches[lang]}</IonLabel>
          </IonCol>

        </IonRow>
      </IonGrid>
      {showSubscriptionAlertForArtistic && <SubscriptionAlert showAlert={showSubscriptionAlertForArtistic} setShowAlert={setShowSubscriptionAlertForArtistic} />}
    </IonCol>
  );
};

export default SidebarMenu;
